/**
 * 借用jqueryui datepicker
 */
(function( factory ) {
  if ( typeof define === "function" && define.amd ) {
    define('jquery.datepicker',['jquery','jquery.widget','jquery.ui'],factory);
  } else {
    factory( jQuery,widget );
  }
}(function($,widget){

  //保存jquery-ui的datepicker方法
  window.$_fn_datepicker = $.fn.datepicker;

  var Datepicker = function(opt){
    this.options = $.extend(true,{},arguments.callee.options,opt);
    this.$el = $(this.options.el);

    //使用jquery-ui的datepicker方法
    $_fn_datepicker.call(this.$el,$.extend(this.options,{
      closeText: "Clear", // Display text for close link
      prevText: "next month", // Display text for previous month link
      nextText: "previous month", // Display text for next month link
      currentText: "Today", // Display text for current month link
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], // Names of months for drop-down and formatting
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    }));

    //由于jquery-ui的datepicker缓存属性与widget冲突，所以返回jqueryui给widget使用。
    this._datepicker = this.$el.data('datepicker');
    return this._datepicker;

  }
  $.extend(Datepicker.prototype,{});
  $.extend(Datepicker,{
    options: {}
  });

  //注册组件，覆盖jquery-ui的datepicker方法
  widget.install('datepicker',Datepicker);

  return Datepicker

}));